import React from "react";
import { altColor } from "../../utils/constants";

export default function LikeButtonSmall({ color = altColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.9 16.09">
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Ebene_1-2" data-name="Ebene 1">
          <g id="Like-Button_small_unfilled_-_V1" data-name="Like-Button small unfilled - V1">
            <path
              fill="none"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.8px"
              x="10.94"
              y="6.9"
              width="3.56"
              height="8.8"
              rx="1.3"
              d="M3.06,9.07H2.41a1.09,1.09,0,1,1,0-2.17H5.94a28.6,28.6,0,0,1-.53-3.74,4.07,4.07,0,0,1,.22-2c.29-.6,1-1,1.48-.56s.46,1.12.54,1.75A9.58,9.58,0,0,0,9,5.65L9.78,7l1.16.22"
            />
            <path
              fill="none"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.8px"
              x="10.94"
              y="6.9"
              width="3.56"
              height="8.8"
              rx="1.3"
              d="M3.06,9.17H1.49a1.09,1.09,0,1,0,0,2.17H3.33"
            />
            <path
              fill="none"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.8px"
              x="10.94"
              y="6.9"
              width="3.56"
              height="8.8"
              rx="1.3"
              d="M3.31,11.31h-.9a1.09,1.09,0,0,0,0,2.18H3.58"
            />
            <path
              fill="none"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.8px"
              x="10.94"
              y="6.9"
              width="3.56"
              height="8.8"
              rx="1.3"
              d="M3.58,13.52H3.19a1.11,1.11,0,0,0-1.13,1,1.08,1.08,0,0,0,1.08,1.15h.71l4.76,0h.13l1.35-.61"
            />
            <rect
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.8px"
              fill="#e8f7f9"
              x="10.94"
              y="6.9"
              width="3.56"
              height="8.8"
              rx="1.3"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
